interface Window {
  acceptCookies: () => void;
}

(function () {
  function acceptCookies() {
      document.cookie = "cookiesAccepted=true; max-age=31536000; path=/";
      closeCookieBanner();
  }

  function closeCookieBanner() {
      document.getElementById('cookieBanner').style.display = 'none';
  }

  function checkCookieConsent() {
      if (document.cookie.indexOf('cookiesAccepted=true') === -1) {
          document.getElementById('cookieBanner').style.display = 'flex';
      }
  }

  window.onload = checkCookieConsent;
  window.acceptCookies = acceptCookies;
})();